import { render, staticRenderFns } from "./StrandPlayerStatisticsScreen.vue?vue&type=template&id=5b579068&scoped=true&"
import script from "./StrandPlayerStatisticsScreen.vue?vue&type=script&lang=js&"
export * from "./StrandPlayerStatisticsScreen.vue?vue&type=script&lang=js&"
import style0 from "./StrandPlayerStatisticsScreen.vue?vue&type=style&index=0&id=5b579068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b579068",
  null
  
)

export default component.exports